<template>
  <v-container
    fluid
    :class="['remote-paginated-list', 'pa-0', { 'full-height': fullHeight }]"
  >
    <v-row
      no-gutters
      v-if="!hideSearch"
      class="remote-paginated-list--filter-row"
    >
      <v-col v-if="$slots['top-left']">
        <slot name="top-left"></slot>
      </v-col>
      <v-col>
        <AdvancedSearchInput
          v-model="search"
          :filter-options="filterOptions"
          :default-filters="filters"
          :exclude-filter-fields="excludedFilterFields"
          @temp-filter-changed="onTempFilterChange"
          @filter="onFilterChange"
        ></AdvancedSearchInput>
      </v-col>
    </v-row>
    <v-data-table
      :loading="isLoading"
      :items="items"
      :server-items-length="itemCount"
      :search="search"
      :options.sync="tableOptions"
      @update:options="onTableOptionUpdated"
      :footer-props="{
        itemsPerPageOptions: [10, 20, 50],
        showFirstLastPage: true,
      }"
      :fixed-header="fullHeight"
      class="remote-paginated-list--table"
      v-bind="$attrs"
    >
      <template #header.data-table-select>
        <!--        <v-simple-checkbox :indeterminate="selectedItemIds.length > 0"-->
        <!--                           @input="selectedAllToggled"-->
        <!--                           :ripple="false"></v-simple-checkbox>-->
      </template>
      <template #item.data-table-select="{ item, select }">
        <v-simple-checkbox
          :value="selectedItemIds.indexOf(item.id) !== -1"
          @input="itemSelected(item)"
          :key="item.id"
          :ripple="false"
        ></v-simple-checkbox>
      </template>
      <template v-for="key in tableTemplateKeys" v-slot:[key]="context">
        <slot :name="key" v-bind="context"></slot>
      </template>
      <template #footer.page-text="{ pageStart, pageStop, itemsLength }">
        <div class="d-flex justify-end">
          <div class="d-flex flex-grow-0 align-center px-2">
            {{ pageStart }}-{{ pageStop }} of {{ itemsLength }}
          </div>
          <div
            class="d-flex flex-grow-0 align-center px-2"
            v-if="!hidePageNoInput"
          >
            P.
          </div>
          <div
            class="d-flex flex-grow-0 align-center"
            style="width: 68px"
            v-if="!hidePageNoInput"
          >
            <v-text-field
              dense
              hide-details
              @input="onPageNoInput"
              :value="tableOptions.page"
              :suffix="`/ ${pageCount}`"
              class="page-no-input"
            ></v-text-field>
          </div>
        </div>
      </template>
    </v-data-table>
    <!--    <v-row no-gutters-->
    <!--           >-->
    <!--      <v-col>-->

    <!--      </v-col>-->
    <!--    </v-row>-->
  </v-container>
</template>

<script>
import { computed, ref, watch } from "@vue/composition-api";
import _ from "lodash";
import AdvancedSearchInput from "./AdvancedSearchInput";
import RemotePaginatedListSelectAllDialog from "./RemotePaginatedListSelectAllDialog";
import { ACTION_TYPES } from "@/store/types";

export default {
  name: "RbuSectionPaginatedList",
  components: { AdvancedSearchInput },
  props: {
    fullHeight: Boolean,
    hideSearch: Boolean,
    filterOptions: Array,
    defaultFilters: Object,
    defaultTableOptions: Object,
    excludedFilterFields: Array,
    value: Array,
    dataUrl: String,
    dataKey: String,
    extraParams: Object,
    extraFilters: Object,
    refreshTrigger: Boolean,
    multiSort: Boolean,
    keepSelectionOnFilter: {
      type: Boolean,
      default: true,
    },
    currentPage: Number,
    itemPerPage: Number,
    totalItemCount: Number,
    hidePageNoInput: Boolean,
  },
  setup(props, { root, emit, slots }) {
    const search = ref("");

    const filters = computed({
      get() {
        return root.$store.state.rbuSectionItemList.rbuSectionListFilter;
      },
      set(filters) {
        updateFilterOptions(filters);
      },
    });

    const updateFilterOptions = (filters) => {
      root.$store.dispatch(ACTION_TYPES.RBU_UPDATE_SECTION_FILTERS, filters);
    };
    const onTempFilterChange = function (value) {
      emit("temp-filter-changed", value);
    };
    const onFilterChange = function (value) {
      filters.value = value;
      emit("filter", value);
      if (!props.keepSelectionOnFilter) {
        selectedItemIds.value = [];
      }
      updateTableOptions({ ...tableOptions.value, page: 1 });
      getItem();
    };

    // Selection
    const selectedItemIds = ref([]);
    watch(
      () => selectedItemIds.value,
      (newValue, oldValue) => {
        if (_.xor(newValue, oldValue).length) {
          emit("input", newValue);
        }
      },
      { deep: true, immediate: true }
    );
    const itemSelected = function (item) {
      let idx = selectedItemIds.value.indexOf(item.id);

      if (idx === -1) {
        selectedItemIds.value = _.union(selectedItemIds.value, [item.id]);
      } else {
        let array = selectedItemIds.value;
        // _.remove(array, (i) => {
        //   return i === item.id;
        // });
        array.splice(idx, 1);
        selectedItemIds.value = array;
      }
    };
    const selectedAllToggled = async function () {
      let action = await root.$dialog.showAndWait(
        RemotePaginatedListSelectAllDialog,
        { title: "Please select your action" }
      );

      if (action === undefined) {
        return;
      }

      if (action === "clear-all") {
        selectedItemIds.value = [];
      } else {
        let params = {
          ...props.extraParams,

          filters: {
            ...filters.value,
            ...props.extraFilters,
          },
          page_no: tableOptions.value.page,
          page_size: tableOptions.value.itemsPerPage,
          sort_by: tableOptions.value.sortBy.map((key, idx) => {
            return tableOptions.value.sortDesc[idx] ? "-" + key : key;
          }),
        };

        let response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: props.dataUrl + "id/",
          params,
        });

        if (action === "unselect") {
          selectedItemIds.value = _.difference(
            selectedItemIds.value,
            response.body.ids
          );
        } else if (action === "select-all") {
          selectedItemIds.value = _.union(
            selectedItemIds.value,
            response.body.ids
          );
        }
      }
    };
    const tableOptions = computed({
      get() {
        return root.$store.state.rbuSectionItemList.rbuSectionListTableOptions;
      },
      set(options) {
        updateTableOptions(options);
      },
    });
    const updateTableOptions = (options) => {
      root.$store.dispatch(
        ACTION_TYPES.RBU_UPDATE_SECTION_TABLE_OPTIONS,
        options
      );
    };
    const onTableOptionUpdated = function (options) {
      emit("update:current-page", options.page);
      emit("update:item-per-page", options.itemsPerPage);
      tableOptions.value = options;
      getItem();
    };

    const tableTemplateKeys = computed(() => {
      return Object.keys(slots);
    });

    // Item
    const isLoading = ref(false);
    const items = ref([]);
    const itemCount = ref(0);
    const pageCount = computed(() => {
      if (itemCount.value) {
        return Math.ceil(itemCount.value / tableOptions.value.itemsPerPage);
      }
      return 1;
    });
    const getItem = _.debounce(async function () {
      let params = {
        ...props.extraParams,

        filters: {
          ...filters.value,
          ...props.extraFilters,
        },
        page_no: tableOptions.value.page,
        page_size: tableOptions.value.itemsPerPage,
        sort_by: tableOptions.value.sortBy.map((key, idx) => {
          return tableOptions.value.sortDesc[idx] ? "-" + key : key;
        }),
      };

      let response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: props.dataUrl,
        params,
      });

      items.value = response.body[props.dataKey];
      itemCount.value = response.body.count;

      emit("update:total-item-count", itemCount.value);
    }, 100);

    const onPageNoInput = _.debounce(function (value) {
      const p = parseInt(value);
      if (p && p <= pageCount.value) {
        // tableOptions.value = {
        //   ...tableOptions.value,
        //   page: p,
        // };
        updateTableOptions({ ...tableOptions.value, page: p });
        getItem();
      }
    }, 500);

    watch(
      () => props.refreshTrigger,
      (newValue, oldValue) => {
        if (newValue) {
          getItem();
          emit("update:refresh-trigger", false);
        }
      }
    );

    watch(
      () => props.value,
      (newValue, oldValue) => {
        if (_.xor(newValue, oldValue).length) {
          selectedItemIds.value = newValue;
        }
      },
      { deep: true, immediate: true }
    );

    watch(
      () => props.extraFilters,
      (newValue, oldValue) => {
        if (newValue && !_.isEqual(newValue, oldValue)) {
          //   tableOptions.value = {
          //     ...tableOptions.value,
          //     page: 1,
          //   };
          updateTableOptions({ ...tableOptions.value, page: 1 });
          getItem();
        }
      },
      { deep: true }
    );

    watch(
      () => props.extraParams,
      (newValue, oldValue) => {
        if (newValue && !_.isEqual(newValue, oldValue)) {
          //   tableOptions.value = {
          //     ...tableOptions.value,
          //     page: 1,
          //   };
          updateTableOptions({ ...tableOptions.value, page: 1 });
          getItem();
        }
      },
      { deep: true }
    );

    return {
      search,
      filters,

      onTempFilterChange,
      onFilterChange,

      selectedItemIds,
      itemSelected,
      selectedAllToggled,

      tableOptions,
      onTableOptionUpdated,

      tableTemplateKeys,

      isLoading,
      items,
      itemCount,
      pageCount,

      onPageNoInput,
    };
  },
};
</script>

<style lang="less">
.remote-paginated-list {
  display: flex;
  flex-direction: column;

  .remote-paginated-list--table {
    th {
      background-color: #faf8f8 !important;
    }
  }

  &.full-height {
    height: 100%;

    .remote-paginated-list--table {
      flex: 1 1 0;
      display: flex;
      flex-direction: column;

      .v-data-table__wrapper {
        flex: 1 1 0;
      }

      .v-data-footer {
        margin-right: 0 !important;
      }
    }
  }

  .remote-paginated-list--filter-row {
    flex: 0 0 auto;
  }

  .page-no-input {
    font-size: 12px !important;
  }
}
</style>
